import LandingContent from "@/components/landing/LandingContent";
import SEO from "@/components/SEO";

const LandingPage = () => (
  <>
    <SEO 
      title="Learn Astrophysics & Physics" 
      description="Scico is a gamified science learning platform for students in grades 6-12 and beyond." 
    />
    <LandingContent />
  </>
);

export default LandingPage;
